import { schema } from 'normalizr'
import { ALL_MEMBERS_ID } from '@/helpers/constants'

// export const profileSchema = new schema.Entity('profiles', {}, {
//   mergeStrategy: (entityA, entityB) => ({
//     ...entityA,
//     ...entityB,
//     teams: [...(entityA || []).teams, ...(entityB || []).teams]
//   }),
//   processStrategy: (entity, parent) => ({ ...entity, teams: [parent.id] })
// })

export const profileSchema = new schema.Entity('profiles')

export const teamSchema = new schema.Entity('teams', {
  members: new schema.Array({
    profile: profileSchema
  })
}, {
  processStrategy: (entity) => {
    if (entity.id === null) {
      entity.id = ALL_MEMBERS_ID
    }
    return entity
  }
})

export const teamsSchema = new schema.Array(teamSchema)

export const kudoSchema = new schema.Entity('kudos')

export const kudosSchema = new schema.Array(kudoSchema)
